module.exports = __webpack_public_path__ + "assets/8235a95af9e19747ef794a05264186eb.png";